import { helpers, React, ts, ui } from '_core';

import { transform } from './helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  file: string;
  fullScreen: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  hasBenchmark: boolean;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, file, hasBenchmark, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: file,
          rename: { build_date: 'date' },
        },
      });
      if (response.data) setData(transform(response.data, hasBenchmark));
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
    />
  );
};
export default Chart;
